import React from 'react';

import { DropdownToggleInterface } from '@neptune/shared/venus-domain';

import type { Widget } from './core-widget-types';

type WidgetActionContextValue = {
  checkbox?: React.ComponentType<{ widget: Widget; onCheckedChange?: (checked: boolean) => void }>;
  exportMenu?: React.ComponentType<{
    widget: Widget;
    toggle?: React.ReactElement<DropdownToggleInterface>;
    onSelect?: () => void;
  }>;
  /** Returns false when `exportMenu` renders no items for the widget. Defaults to true. */
  hasExportMenuItems?: (widget: Widget) => boolean;
};

export const WidgetActionContext = React.createContext<WidgetActionContextValue>({});

/** The export menu for the widget, or undefined when it would render no items. */
export function useWidgetExportMenu(widget: Widget): WidgetActionContextValue['exportMenu'] {
  const { exportMenu, hasExportMenuItems } = React.useContext(WidgetActionContext);

  if (hasExportMenuItems && !hasExportMenuItems(widget)) {
    return undefined;
  }

  return exportMenu;
}
